var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"topic-secondary"},[_vm._v(_vm._s(_vm.eng))]),_c('div',{staticClass:"pl-5 topic-border"},[_c('div',{staticClass:"topic-primary"},[_vm._v(_vm._s(_vm.thai))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }